// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GZlkx","index":"styles_index__21NgB"};